import { useModalCountdown } from "@/react/components/FormRenderer/hooks/useModalCountdown";
import type { ElementType } from "@/react/types/Element";
import type { Form as FormType } from "@/react/types/Form";

interface ShowModalProps {
  form: FormType;
  formElements: ElementType[];
  index: number;
  popupDelay: number;
  popupFrequency: number;
}

export const ShowModal = ({
  form,
  index,
  formElements,
  popupDelay,
  popupFrequency,
}: ShowModalProps) => {
  useModalCountdown({
    form,
    index,
    formElements,
    popupDelay,
    popupFrequency,
  });

  return null;
};
